export default function formatLastUpdate(lastUpdate) {
  const lastUpdateDate = new Date(lastUpdate);
  const isToday = new Date(lastUpdate).setHours(0, 0, 0, 0) === new Date().setHours(0, 0, 0, 0);
  const options = isToday
    ? {
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
      }
    : {
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
        month: 'short',
        day: '2-digit',
      };
  const lastUpdateString = lastUpdateDate.toLocaleString('en-US', options);

  if (isToday) {
    return `Today, ${lastUpdateString}`;
  }
  return lastUpdateString;
}



// WEBPACK FOOTER //
// ./src/helpers/formatLastUpdate.js